import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import defaultStyles from './TitleCell.module.scss';

const TitleCell = props => (
    <div className={ classnames({
        [props.styles.csaTitle]: props.titleRow
    }) }
    >
        {props.value}
    </div>
);

TitleCell.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
    titleRow: PropTypes.bool,
    value: PropTypes.string

};

TitleCell.defaultProps = {
    styles: defaultStyles,
    titleRow: false,
    value: ''
};

export default TitleCell;
